<template>
  <div class="row">
    <div class="col-md-8 offset-md-2 foreground-content">
      <h1 class="mb-5">
        {{ group.name }}
      </h1>
      <div class="description" v-html="group.descriptionHtml" />
      <div class="mt-4 mb-2">
        <join-button v-if="showJoin" />
        <request-to-join-button v-if="showRequestToJoin" />

        <div v-if="showLogin" class="mt-2">
          <span>{{ i18n.t('local_chapters.show.already_member') }}</span>
          <a :href="signInUrl">
            {{ i18n.t('local_chapters.show.log_in') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import JoinButton from './join-button'
import RequestToJoinButton from './request-to-join-button'

const SIGN_IN_URL = '/users/sign_in'

export default {
  components: { JoinButton, RequestToJoinButton },

  data() {
    return {
      signInUrl: SIGN_IN_URL
    }
  },

  computed: {
    ...mapGetters(['showJoin', 'showRequestToJoin']),
    ...mapState(['group', 'userIsLoggedIn']),

    showLogin() {
      return !this.userIsLoggedIn
    }
  }
}
</script>
